import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import App          from './modules/App';
import Home         from './modules/Home';
import Location     from './modules/location/Location';
import NotFound     from './modules/NotFound';
import './index.css';

render((
	<Router history={browserHistory}>
		<Route path="/" component={App}>
			<IndexRoute component={Home}/>
			<Route path="/location" component={Location}/>
			<Route path="*" component={NotFound} />
		</Route>
	</Router>
), document.getElementById('InSiteLocation'))




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/